import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CUSTOMER_RESOURCE } from './schema';

const QUERY = gql`
  query CustomerResources($customerId: ID!) {
    customerResource(customerId: $customerId) {
      ...PerformanceCenterCustomerResource
    }
  }
  ${FRAGMENT_CUSTOMER_RESOURCE}
`;

export const queryCustomerResources = (customerId) => {
  return executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
    },
  }).then(({ data }) => getSingleProp(data));
};
